// Others
import axiosClient from './axiosClient';
import { urlApiTruck } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate } from '~/utils/interface/common';
import { ITruckDetail, IFormTruck, IQueryParamTruck, ITruck } from '~/utils/interface/truck';

const truckApi = {
  getListTruck: (params: IQueryParamTruck) => {
    const url = urlApiTruck.getListTruck;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITruck[]>>>(url, { params });
  },

  getDetailTruck: (id: string) => {
    const url = urlApiTruck.getDetailTruck(id);
    return axiosClient.get<IBaseResponse<ITruckDetail>>(url);
  },

  createTruck: (body: IFormTruck) => {
    const url = urlApiTruck.createTruck;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateTruck: (params: IBodyUpdate<IFormTruck>) => {
    const { id, body } = params;
    const url = urlApiTruck.updateTruck(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteTruck: (id: string) => {
    const url = urlApiTruck.deleteTruck(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default truckApi;
